// frontend/src/services/analyticsService.js
const GA_MEASUREMENT_ID = 'G-ZYD6QP1GQZ';

export const setGAUserId = (userId) => {
  if (typeof window.gtag === 'function') {
    if (userId) {
      window.gtag('set', {'user_id': userId});
      console.log('Google Analytics User-ID via "set" gesetzt:', userId); // Kann bleiben oder entfernt werden

    } else {
      window.gtag('set', {'user_id': null});
      console.log('Google Analytics User-ID via "set" entfernt.'); // Kann bleiben oder entfernt werden
    }
  } else {
    console.warn('gtag Funktion nicht verfügbar...');
  }
};

// trackGAEvent und trackGAPageView können so bleiben.
export const trackGAEvent = (eventName, eventParams) => {
  if (typeof window.gtag === 'function') {
    window.gtag('event', eventName, eventParams);
  } else {
    console.warn(`gtag Funktion nicht verfügbar. GA Event "${eventName}" nicht getrackt.`);
  }
};

export const trackGAPageView = (path) => {
  if (typeof window.gtag === 'function') {
    window.gtag('config', GA_MEASUREMENT_ID, {
      'page_path': path,
    });
  } else {
    console.warn('gtag Funktion nicht verfügbar. Google Analytics Pageview nicht getrackt.');
  }
};